import { authGet } from './authMiddleware';

export const getCompanyProfile = async (id) => {
    return authGet(`/api/Company?CompanyId=${id}`);
}